import { createFileRoute, redirect } from '@tanstack/react-router'

import { signatureCoursesQueries } from '@/http/api/signatureCourses'

export const Route = createFileRoute(
  '/_learning/discover/course-generic/$courseSlug',
)({
  beforeLoad: async ({ context, params }) => {
    const courses = await context.queryClient
      .ensureQueryData(signatureCoursesQueries.allAvailable())
      .then(({ signature_courses }) => signature_courses)
      .catch(() => undefined)

    if (courses && !courses.some(({ slug }) => slug === params.courseSlug)) {
      throw redirect({ to: '/home' })
    }
  },
})
